import { Component, OnDestroy, OnInit } from '@angular/core';

interface StepperItem {
  title: string;
  body: string;
  num?: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  hiwSteps: StepperItem[] = [
    {
      num: '01',
      title: 'Entegre Edin',
      body: 'Sitenize Google Tag Manager (GTM) üzerinden entegre olur. Tüm e-ticaret platformlarıyla uyumlu, dakikalar içinde aktif.'
    },
    {
      num: '02',
      title: 'Verinizle Eğitin',
      body: 'Ürün kataloğunuz, SSS dokümanlarınız ve şirket bilgilerinizle özelleştirilir. Markanızın sesinde yanıt verir.'
    },
    {
      num: '03',
      title: 'Sesli ve Yazılı Yanıtlar',
      body: 'Voice Agent ile telefon konuşması doğallığında sesli destek, yazılı kanalda anlık mesajlaşma. Ürün karşılaştırması, fiyat sorgulama ve marka soruları tek akışta.'
    },
    {
      num: '04',
      title: 'Destek Talebine Otomatik Geçiş',
      body: '"İade", "iptal" ve "şikayet" gibi tetikleyicileri algılar; konuşmayı detaylı özet ve aciliyet seviyesi (Yüksek/Orta/Düşük) ile insan ekibinize aktarır.'
    },
    {
      num: '05',
      title: 'AI Rapor Asistanı ile Analiz Edin',
      body: 'Konuşma verilerinizi yapay zeka rapor asistanına sorarak içgörü elde edin: en sık şikayet konuları, en çok sorgulanan ürünler, ortalama çözüm süreleri.'
    }
  ];

  benefitItems: StepperItem[] = [
    {
      title: 'Voice Agent ile İnsani Deneyim',
      body: 'Müşterileriniz yazmadan, telefon konuşması doğallığında sesle iletişim kurar.'
    },
    {
      title: 'Müşteri Hizmetleri Maliyetini Düşürün',
      body: '7/24 otomatik yanıt ile insan agent ihtiyacını azaltın.'
    },
    {
      title: 'Çok Kanallı Destek',
      body: 'Web, WhatsApp, Instagram, Facebook ve sesli kanal üzerinden kesintisiz müşteri iletişimi.'
    },
    {
      title: 'Merkezi Yönetim Paneli',
      body: 'Konuşma geçmişi, müşteri listesi ve destek talepleri tek ekrandan yönetilir.'
    },
    {
      title: 'Veri Odaklı Karar Alın',
      body: 'Müşteri şikayetleri, sık sorulan sorular ve destek yükü raporlarla görünür hale gelir.'
    }
  ];

  activeHiw = 0;
  activeBenefit = 0;

  private hiwTimer: any;
  private benefitTimer: any;
  private readonly hiwCycleMs = 10000;
  private readonly benefitCycleMs = 10000;

  ngOnInit(): void {
    this.startHiwCycle();
    this.startBenefitCycle();
  }

  ngOnDestroy(): void {
    clearInterval(this.hiwTimer);
    clearInterval(this.benefitTimer);
  }

  selectHiw(i: number): void {
    this.activeHiw = i;
    this.startHiwCycle();
  }

  selectBenefit(i: number): void {
    this.activeBenefit = i;
    this.startBenefitCycle();
  }

  private startHiwCycle(): void {
    clearInterval(this.hiwTimer);
    this.hiwTimer = setInterval(() => {
      this.activeHiw = (this.activeHiw + 1) % this.hiwSteps.length;
    }, this.hiwCycleMs);
  }

  private startBenefitCycle(): void {
    clearInterval(this.benefitTimer);
    this.benefitTimer = setInterval(() => {
      this.activeBenefit = (this.activeBenefit + 1) % this.benefitItems.length;
    }, this.benefitCycleMs);
  }

  /* ===== Glassmorphism feature card — 3D tilt + glare ===== */

  onFeatureMove(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const rect = card.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const ry = ((x - cx) / cx) * 7;
    const rx = ((y - cy) / cy) * -7;
    card.style.setProperty('--rx', `${rx}deg`);
    card.style.setProperty('--ry', `${ry}deg`);
    card.style.setProperty('--mx', `${x}px`);
    card.style.setProperty('--my', `${y}px`);
  }

  onFeatureLeave(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
  }
}
